import { TOGGLE_DRAWER } from './types';

export const toggleDrawer = (isOpen) => (dispatch) => {
	dispatch({
		type: TOGGLE_DRAWER,
		payload: isOpen,
	});
};
